import script from "./transportPayReview.vue?vue&type=script&setup=true&lang=js"
export * from "./transportPayReview.vue?vue&type=script&setup=true&lang=js"

import "./transportPayReview.vue?vue&type=style&index=0&id=4e283b36&lang=less"

const __exports__ = script;

export default __exports__